import type { TextProps } from "@/types";

/**
 * Text Component
 * Renders paragraph text with size and color variants
 */
export const Text = ({
  children,
  size = 'base',
  className = '',
  color,
}: TextProps) => {
  // Responsive size classes with proper line heights
  const sizeClasses = {
    sm: 'text-sm md:text-base leading-relaxed',
    base: 'text-base md:text-lg leading-relaxed',
    lg: 'text-lg md:text-xl leading-relaxed',
    xl: 'text-xl md:text-2xl leading-relaxed',
  };

  // Color class (if provided)
  const colorClass = color ? color : 'text-theme-text-secondary';

  return (
    <p className={`${sizeClasses[size]} ${colorClass} ${className}`}>
      {children}
    </p>
  );
};

export default Text;
